"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _Alert = _interopRequireDefault(require("./Alert"));

var _Markdown = _interopRequireDefault(require("./text/Markdown"));

var _styling = require("../toolkit/styling");

var _providers = require("../toolkit/providers");

//
//  MultilineAlert.tsx
//  Project-Lego
//
//  Created by Mengyu Yuan on 12/12/19.
//  Copyright © 2019-present ContextLogic Inc. All rights reserved.
//

/* Lego Components */

/* Lego Toolkit */
var propDoc = {
  title: {
    required: false,
    defaultValue: "null",
    type: "string | ((() => ReactNode))",
    description: "Optional title of the alert. Most bolded line"
  },
  lines: {
    required: true,
    type: "Array<string>",
    description: "Each line of text, in markdown format"
  },
  sentiment: {
    required: true,
    type: "\"positive\" | \"negative\" | \"warning\" | \"info\"",
    description: "Sentiment of the message - determines the color treatment"
  }
};
var demoProps = {
  title: "Title",
  lines: ["- **line1** line1 text [link](https://www.google.com)", "- **line2** line2 text"],
  sentiment: "warning"
};

var MultilineAlert = function MultilineAlert(props) {
  var styles = useStylesheet();

  var renderline = function renderline(line) {
    return /*#__PURE__*/_react["default"].createElement(_Markdown["default"], {
      key: line,
      text: line,
      listStyle: styles.list,
      style: styles.line
    });
  };

  var renderlines = function renderlines(lines) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, lines.map(function (line) {
      return renderline(line);
    }));
  };

  var title = props.title,
      lines = props.lines,
      className = props.className,
      style = props.style,
      sentiment = props.sentiment;
  return /*#__PURE__*/_react["default"].createElement(_Alert["default"], {
    className: (0, _styling.css)(className, style),
    title: title,
    sentiment: sentiment,
    text: function text() {
      return renderlines(lines);
    }
  });
};

MultilineAlert.propDoc = propDoc;
MultilineAlert.demoProps = demoProps;

var _default = (0, _mobxReact.observer)(MultilineAlert);

exports["default"] = _default;

var useStylesheet = function useStylesheet() {
  var _useTheme = (0, _providers.useTheme)(),
      textDark = _useTheme.textDark;

  return (0, _react.useMemo)(function () {
    return _aphrodite.StyleSheet.create({
      list: {
        paddingLeft: 15,
        margin: 0
      },
      line: {
        color: textDark,
        margin: "8px 0"
      }
    });
  }, [textDark]);
};